import { render, staticRenderFns } from "./PartnerSso.vue?vue&type=template&id=93bbb1e2&scoped=true"
import script from "./PartnerSso.vue?vue&type=script&lang=js"
export * from "./PartnerSso.vue?vue&type=script&lang=js"
import style0 from "./PartnerSso.vue?vue&type=style&index=0&id=93bbb1e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93bbb1e2",
  null
  
)

export default component.exports